import module from '@app/ui/module'
import template from './template.html'

export class AppUiThemeSwitchComponent {
  constructor ($element, $localStorage, $scope) {
    this.$localStorage = $localStorage
    this.parent = $element[0].closest('body')
    this.isNight = $localStorage.isNight
    this.onChange = undefined
    this.$scope = $scope

    this.$scope.$watch(() => $localStorage.isNight, (isNight) => {
      if (this.isNight !== isNight) this.setNight(isNight)
    })
  }

  $onInit () {
    this.setNight(this.isNight)
  }

  toggle () {
    this.isNight = !this.isNight
    this.render()
    this.update()
  }

  setNight (isNight) {
    this.isNight = !!isNight
    this.render()
    this.update()
  }

  render () {
    this.$localStorage.isNight = this.isNight
    this.parent.classList.toggle('theme--night', this.isNight)
  }

  update () {
    this.onChange({$event: {data: {isnight: this.isNight}}})
  }
}

module.component('appUiThemeSwitch', {
  controller: AppUiThemeSwitchComponent,
  template: template,
  bindings: {
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/app/ui/components/theme-switch/component.js